import Avatar from '-/Custom/Avatar';
import * as Header from '-/Custom/Header';
import { Link, Stack } from 'expo-router';
import Animated from 'react-native-reanimated';
import { StyleSheet } from 'react-native-unistyles';
import { useQuery } from 'urql';
import PersonProfileMasthead, {
  usePersonProfileHeaderAnimation,
} from '@/components/Person/PersonProfileMasthead';
import ActionButton from '@/components/UI/ActionButton';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';
import ProfileMenu from './components/ProfileMenu';

const GetProfileHome = graphql(/* GraphQL */ `
  query GetProfileHome {
    current_user {
      id
      name
      avatar_id
      color
    }
  }
`);

export default function ProfileHome() {
  const {
    scrollViewRef,
    scrollY,
    compactHeaderAnimatedProps,
    compactHeaderAnimatedStyle,
  } = usePersonProfileHeaderAnimation();

  const [{ data }] = useQuery({
    query: GetProfileHome,
  });

  const name = data?.current_user?.name || '';
  const avatarId = data?.current_user?.avatar_id || '';

  return (
    <>
      <Stack.Screen
        options={{
          headerBackTitle: '',
          headerBackButtonDisplayMode: 'minimal',
          title: name || 'Profile',
          headerTitle: () => (
            <Animated.View
              animatedProps={compactHeaderAnimatedProps}
              style={compactHeaderAnimatedStyle}
            >
              <Header.MastheadTitleContainer>
                <Avatar
                  id={avatarId}
                  size="md"
                  color={data?.current_user?.color}
                  name={name}
                />
                <Text size="xl" numberOfLines={1} flexShrink={1}>
                  {name}
                </Text>
              </Header.MastheadTitleContainer>
            </Animated.View>
          ),
        }}
      />

      <Animated.ScrollView
        ref={scrollViewRef}
        contentContainerStyle={styles.content}
        contentInsetAdjustmentBehavior="automatic"
        testID="ProfileHome"
      >
        <PersonProfileMasthead
          avatarId={avatarId}
          color={data?.current_user?.color}
          name={name}
          profileLabel=""
          scrollY={scrollY}
          surfaceStyle={styles.masthead}
          testID="ProfileMasthead"
          actionContent={
            <Link href="/profile/name" asChild>
              <ActionButton
                forceLabel
                icon="create-outline"
                label="Edit Profile"
                variant="secondary"
              />
            </Link>
          }
        />
        <ProfileMenu />
      </Animated.ScrollView>
    </>
  );
}

const styles = StyleSheet.create((theme) => ({
  masthead: {
    backgroundColor: theme.colors.surface,
  },
  content: {
    flexGrow: 1,
    paddingBottom: theme.space('4xl') * 3,
  },
}));
